import { create } from 'zustand'

type RfiModalState = {
  showPendingRfiModal: boolean
  setShowPendingRfiModal: (show: boolean) => void
}

export const useRfiModalStore = create<RfiModalState>((set) => ({
  showPendingRfiModal: false,
  setShowPendingRfiModal: (show: boolean) => set({ showPendingRfiModal: show }),
}))
